import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "ends_at": {
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "date"
      },
      "name": "ends_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "starts_at": {
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "date"
      },
      "name": "starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "subscription_id": {
      "column": {
        "default": null,
        "name": "subscription_id",
        "null": false,
        "type": null
      },
      "name": "subscription_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SubscriptionPeriod",
  "collectionKey": "subscription_periods",
  "collectionName": "subscription_periods",
  "i18nKey": "subscription_period",
  "camelizedLower": "subscriptionPeriod",
  "name": "SubscriptionPeriod",
  "nameDasherized": "subscription-period",
  "pluralName": "subscription_periods",
  "ransackable_associations": [
    {
      "className": "SubscriptionPeriod::Audit",
      "collectionName": "subscription_period_audits",
      "foreignKey": "subscription_period_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SubscriptionPeriodAudit",
      "through": null
    },
    {
      "className": "SubscriptionPeriod::Audit",
      "collectionName": "subscription_period_audits",
      "foreignKey": "subscription_period_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SubscriptionPeriodAudit",
      "through": null
    },
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "resource_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "has_one",
      "resource_name": "Plan",
      "through": "subscription"
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "subscription_id",
      "name": "subscription",
      "macro": "belongs_to",
      "resource_name": "Subscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": false,
        "type": "date"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": false,
        "type": "date"
      }
    },
    {
      "name": "subscription_id",
      "column": {
        "default": null,
        "name": "subscription_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Invoice",
      "collectionName": "invoices",
      "foreignKey": "resource_id",
      "name": "invoice",
      "macro": "has_one",
      "resource_name": "Invoice",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "subscription_id",
      "name": "subscription",
      "macro": "belongs_to",
      "resource_name": "Subscription",
      "through": null
    }
  ],
  "paramKey": "subscription_period",
  "primaryKey": "id"
}

/** Frontend model for SubscriptionPeriod. */
class SubscriptionPeriod extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  endsAt() {
    return this.readAttributeUnderscore("ends_at")
  }

  /** @returns {boolean} */
  hasEndsAt() {
    const value = this.endsAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  startsAt() {
    return this.readAttributeUnderscore("starts_at")
  }

  /** @returns {boolean} */
  hasStartsAt() {
    const value = this.startsAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  subscriptionId() {
    return this.readAttributeUnderscore("subscription_id")
  }

  /** @returns {boolean} */
  hasSubscriptionId() {
    const value = this.subscriptionId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./invoice.js").default | null} */
  invoice() {
    return this._readHasOneReflection({reflectionName: "invoice"})
  }

  /** @returns {Promise<import("./invoice.js").default | null>} */
  loadInvoice() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const modelClass = modelClassRequire("Invoice")
    const ransack = {}

    ransack["resource_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "invoice",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./subscription.js").default | null} */
  subscription() {
    return this._readBelongsToReflection({reflectionName: "subscription"})
  }

  /** @returns {Promise<import("./subscription.js").default | null>} */
  loadSubscription() {
    if (!("subscriptionId" in this)) throw new Error("Foreign key method wasn't defined: subscriptionId")

    const id = this.subscriptionId()
    const modelClass = modelClassRequire("Subscription")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "subscription", model: this, modelClass},
      {ransack}
    )
  }
}

export default SubscriptionPeriod
